// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundingMethodSpecificResponseDto
 */
export interface IFundingMethodSpecificResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    calculated_prefund?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    prefund_holding?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    replenishment_to_be_invoiced?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    replenishment_not_received?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    contributions_total_received?: number;
    /**
     * 
     * @type {number}
     * @memberof IFundingMethodSpecificResponseDto
     */
    contributions_not_yet_received?: number;
}

/**
 * Check if a given object implements the IFundingMethodSpecificResponseDto interface.
 */
export function instanceOfIFundingMethodSpecificResponseDto(value: object): value is IFundingMethodSpecificResponseDto {
    return true;
}

export function IFundingMethodSpecificResponseDtoFromJSON(json: any): IFundingMethodSpecificResponseDto {
    return IFundingMethodSpecificResponseDtoFromJSONTyped(json, false);
}

export function IFundingMethodSpecificResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundingMethodSpecificResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calculated_prefund': json['calculated_prefund'] == null ? undefined : json['calculated_prefund'],
        'prefund_holding': json['prefund_holding'] == null ? undefined : json['prefund_holding'],
        'replenishment_to_be_invoiced': json['replenishment_to_be_invoiced'] == null ? undefined : json['replenishment_to_be_invoiced'],
        'replenishment_not_received': json['replenishment_not_received'] == null ? undefined : json['replenishment_not_received'],
        'contributions_total_received': json['contributions_total_received'] == null ? undefined : json['contributions_total_received'],
        'contributions_not_yet_received': json['contributions_not_yet_received'] == null ? undefined : json['contributions_not_yet_received'],
    };
}

export function IFundingMethodSpecificResponseDtoToJSON(json: any): IFundingMethodSpecificResponseDto {
    return IFundingMethodSpecificResponseDtoToJSONTyped(json, false);
}

export function IFundingMethodSpecificResponseDtoToJSONTyped(value?: IFundingMethodSpecificResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calculated_prefund': value['calculated_prefund'],
        'prefund_holding': value['prefund_holding'],
        'replenishment_to_be_invoiced': value['replenishment_to_be_invoiced'],
        'replenishment_not_received': value['replenishment_not_received'],
        'contributions_total_received': value['contributions_total_received'],
        'contributions_not_yet_received': value['contributions_not_yet_received'],
    };
}

